import { QueryKey } from "@tanstack/react-query";

export const leadSourceAsPublicQueryKeys = {
  all: () => ["leadSourceAsPublic"] as QueryKey,
  list: () => [...leadSourceAsPublicQueryKeys.all(), "list"] as QueryKey,
};
